export enum ViewType {
    NEW = "NEW",
    CHANGE = "CHANGE",
    KORREX = "KORREX",
    NEW_EXTERNAL = "NEW_EXTERNAL"
}
